class Other {

  static cards() {
    return {
    }
  }
}

export default Other;
